import client from './client';

export const getProductSummary = async (orderSheetId: string, storeId?: string) => {
    const response = await client.get(`reports/product-summary/${orderSheetId}`, {
        params: { storeId }
    });
    return response.data;
};

export const getCustomerReceipts = async (orderSheetId: string, storeId?: string) => {
    const response = await client.get(`reports/customer-receipts/${orderSheetId}`, {
        params: { storeId }
    });
    return response.data;
};

export const getDeliverySummary = async (orderSheetId: string, storeId?: string) => {
    const response = await client.get(`reports/delivery-summary/${orderSheetId}`, {
        params: { storeId }
    });
    return response.data;
};
